import { render, staticRenderFns } from "./PublishUnpublishComponent.vue?vue&type=template&id=61d48290&"
import script from "./PublishUnpublishComponent.vue?vue&type=script&lang=js&"
export * from "./PublishUnpublishComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports